const DEFAULT_BASE = 'https://globalwork-production.s3.amazonaws.com'

/**
 * URL de assets estáticos en S3 (ilustraciones, iconos, PDFs legales).
 * Configurar VUE_APP_PUBLIC_ASSETS_URL en build/deploy.
 */
export function publicAssetUrl(path) {
  const base = (process.env.VUE_APP_PUBLIC_ASSETS_URL || DEFAULT_BASE).replace(/\/+$/, '')
  const key = String(path || '').replace(/^\/+/, '')
  return `${base}/${key}`
}

export default publicAssetUrl
